import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.496 0h-2v2h-6V0h-2v2h-.4c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C.496 2.76.496 3.04.496 3.6v8.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109H4.17a7 7 0 0 1 10.326-8.745V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.736 2 13.456 2 12.896 2h-.4V0Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.385 8c-1.57 0-2.889 1.316-2.889 3s1.32 3 2.889 3c.932 0 1.77-.46 2.303-1.19l1.616 1.18c-.886 1.212-2.308 2.01-3.92 2.01-2.726 0-4.888-2.265-4.888-5s2.162-5 4.889-5a4.84 4.84 0 0 1 3.787 1.838l1.32-.943.012 4.718-4.459-1.54 1.496-1.07A2.835 2.835 0 0 0 10.385 8Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconFunctionalUpdateDate16 = createIcon(IconComponent);